import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FuelModalService {

  private selectedFuelSubject = new BehaviorSubject<any>(null);
  public selectedFuel$ = this.selectedFuelSubject.asObservable();

  constructor() { }

  setSelectedFuel(fuel: any): void {
    this.selectedFuelSubject.next(fuel);
  }

  getSelectedFuel(): any | null {
    return this.selectedFuelSubject.value;
  }

  clearSelectedFuel(): void {
    this.selectedFuelSubject.next(null);
  }
}
